module.exports = __webpack_public_path__ + "img/list_active.0031b04b.svg";